export const useIsEqualParagraphTokenFormatting = (formatting1: ParagraphTokenFormatting, formatting2: ParagraphTokenFormatting) => {

  if (formatting1.size != formatting2.size) {
    return false;
  }

  for (const key in formatting1) {
    if ((formatting1 as any)[key] != (formatting2 as any)[key]) {
      return false;
    }
  }

  for (const key in formatting2) {
    if ((formatting2 as any)[key] != (formatting1 as any)[key]) {
      return false;
    }
  }

  return true;

}